<script>
// A labelled form row: label, the control (default slot), then the error if
// there is one, else the hint. Keeps the modals short and the spacing equal.
export default {
  name: 'FormField',
  props: {
    label: { type: String, required: true },
    forId: { type: String, default: '' },
    error: { type: String, default: '' },
    hint: { type: String, default: '' },
  },
};
</script>

<template>
  <div>
    <label
      :for="forId"
      class="block mb-1 text-sm text-slate-700 dark:text-slate-200"
    >
      {{ label }}
    </label>
    <slot />
    <p v-if="error" class="mt-1 text-xs text-red-500">{{ error }}</p>
    <p v-else-if="hint" class="mt-1 text-xs text-slate-500 dark:text-slate-400">
      {{ hint }}
    </p>
  </div>
</template>
